import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ValueTagList from "./valueTagList";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ComponentBackdrop from "../../components/backdrop";
import toast from "react-hot-toast";
import { useApiClient } from "../../context/ApiClientContext";
import axios from "axios";
import GridToolbar from "./GridToolbar";
import dayjs from "dayjs";
import api from "../../helper/baseApi";
import SuccessAlert from "../../helper/successAlert";
import { CheckCircle } from "@mui/icons-material";
import ErrorAlert from "../../helper/errorAlert";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
export const DataContext = React.createContext();

const ValueTagHeaderForm = ({ mode, valueTagHeaderDetails, valueTagSet, onModeChange, onRefetch }) => {
  const { id } = useParams();
  const labelWidth = 150;
  const [errors, setErrors] = useState({});
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [totalPage, setTotalPage] = React.useState();
  const [pageSize, setPageSize] = React.useState();
  const [allowAdd, setAllowAdd] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    apiUrls: { mobileApiUrl },
  } = useApiClient();

  const navigate = useNavigate();

  const [headId, setHeadId] = useState();
  const [showButton, setShowButton] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  // const today = new Date();
  // // Format: YYYY-MM-DD
  // const formatDate = (date) => date.toISOString().split("T")[0];

  // const defaultStart = formatDate(today);

  // const nextYear = new Date(today);
  // nextYear.setFullYear(today.getFullYear() + 1);
  // const defaultEnd = formatDate(nextYear);

  const [inputForm, setInputForm] = useState({
    code: "",
    startDate: "", // today
    endDate: "",     // +1 year
  });

  useEffect(() => {
    if (mode === "edit" || mode === "view") {
      const headerData = valueTagHeaderDetails || {};

      setHeadId(headerData.valueTagHeaderId);

      setInputForm({
        ...headerData,
        code: headerData.code,
        startDate: headerData.startDate ? dayjs(headerData.startDate).format("YYYY-MM-DD") : "",
        endDate: headerData.endDate ? dayjs(headerData.endDate).format("YYYY-MM-DD") : "",
      });
    } else {
      setInputForm({
        code: "",
        startDate: "",
        endDate: "",
      });
    }
  }, [mode, valueTagHeaderDetails]);

  const handleShowButton = (ids) => {
    setSelectedIds(ids);
    setShowButton(ids.length > 0);
  };
  const handleInputChange = (property, event) => {
    console.log("value", event.target.value);
    const value = event.target.value;
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const renderField = (
    label,
    id,
    type = "text",
    select = false,
    options = [],
    disabled = false
  ) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
        }}
      >
        {label}
      </Typography>
      <TextField
        id={id}
        type={type}
        select={select}
        slotProps={{
          input: { readOnly: disabled }
        }}
        error={!!errors[id]}
        helperText={errors[id]}
        onChange={(e) => handleInputChange(id, e)}
        value={inputForm[id]}
        required
        fullWidth
        size="small"
        variant="outlined"
      >
        {select &&
          options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
      </TextField>
    </Box>
  );

  const renderYearField = (label, id, disabled = false) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: labelWidth },
          alignSelf: { sm: "center" },
        }}
      >
        {label}
      </Typography>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          views={["year"]}
          disabled={disabled}
          format="DD/MM/YYYY"
          value={inputForm[id] ? dayjs(inputForm[id]) : null}
          onChange={(newValue) => {
            if (newValue) {
              const year = newValue.year();
              setInputForm((prev) => ({
                ...prev,
                [id]: id === "startDate"
                  ? `${year}-01-01`
                  : `${year}-12-31`, // 👈 Start = Jan 1, End = Dec 31
              }));
            }
          }}
          slotProps={{
            textField: {
              size: "medium", fullWidth: true, sx: {
                "& .MuiPickersSectionList-sectionContent": {
                  fontSize: "14px",
                  lineHeight: "1.2",
                },
              },
              fullWidth: true,
              size: "small",
              error: !!errors[id],
              helperText: errors[id],
              input: { readOnly: disabled }
            },
            popper: {
              placement: "bottom-end", // 👈 aligns popup to right side
            },
          }}
        />
      </LocalizationProvider>
    </Box>
  );

  const changeEdit = () => {
    onModeChange("edit");
  };

  const submitForm = async () => {
    // basic required check
    const newErrors = {};
    if (!inputForm.code?.trim()) {
      newErrors.code = "Group is required.";
    }
    if (!inputForm.startDate) {
      newErrors.startDate = "Start year is required.";
    }
    if (!inputForm.endDate) {
      newErrors.endDate = "End year is required.";
    }

    setErrors(newErrors);

    // stop if any validation failed
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setOpenBackdrop(true);

      let response = "";
      let apiUrl = "";

      if (mode === "edit") {
        apiUrl = `${mobileApiUrl}valueTag/update-header`;
        response = await api.put(apiUrl, {
          valueTagHeaderId: id,
          code: inputForm.code,
          startDate: inputForm.startDate,
          endDate: inputForm.endDate,
        });
      } else {
        apiUrl = `${mobileApiUrl}valueTag/create-vt-header`;
        response = await api.post(apiUrl, {
          code: inputForm.code,
          startDate: inputForm.startDate,
          endDate: inputForm.endDate,

        });
      }

      console.log(response.data.data);
      if (response.status === 200) {
        setTimeout(() => {
          setOpenBackdrop(false);
          // setAllowAdd(mode === "edit" ? false : true);
          if (mode === "create" && response.data?.data) {

            const newId = response.data.data.valueTagHeaderId;
            setHeadId(newId);

            // ✅ update parent mode
            onModeChange("edit");

            // ✅ navigate to edit page with id
            navigate(`/edit-valuetag/${newId}`);

            // ✅ refetch details with new id
            onRefetch(newId);
          } else {
            onRefetch();
          }
          SuccessAlert(response.data.message);
        }, 1000);
      }
    } catch (error) {
      setTimeout(() => {
        setOpenBackdrop(false);
        ErrorAlert(error, navigate);
      }, 500);
    } finally {
      if (mode === "edit") {
        onModeChange("view");
      }
    }
  };

  const SubmitButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={() => submitForm("Successfully created.")}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
          //   mb: 3,
        }}
      >
        Save
      </Button>
    </Box>
  );
  const EditButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={mode === "edit" ? submitForm : changeEdit}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
        }}
      >
        {mode === "edit" ? "Save" : "Edit"}
      </Button>
    </Box>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Box width="100%" display="flex" justifyContent="flex-end" mb={4}>
        {mode === "create" ? (
          <SubmitButton />
        ) : (
          <EditButton changeEdit={changeEdit} />
        )}{" "}
      </Box>

      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid size={{ xs: 12 }}>
          {renderField("Group", "code", "text", false, [], mode === "view")}
          {renderYearField("Start Year", "startDate", mode === "view")}
          {renderYearField("End Year", "endDate", mode === "view")}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column" },
              gap: 1,
              mb: 2,
            }}
          >
            <Typography
              sx={{
                minWidth: { sm: labelWidth },
                alignSelf: { sm: "start" },
                marginTop: "13px",
              }}
            >
              Value Tag
            </Typography>

            <ValueTagList
              valueTagSet={valueTagSet}
              allowAdd={allowAdd}
              currentPage={currentPage}
              totalPage={totalPage}
              pageSize={pageSize}
              headerId={headId}
              handleShowButton={handleShowButton}
              onRefetch={onRefetch}
            />
          </Box>
        </Grid>
      </Grid>
      <ComponentBackdrop openBackdrop={openBackdrop} />
    </Box>
  );
};

export default ValueTagHeaderForm;